// Theme.css defines --bs-danger-rgb wrong (it's a copy of the green success
// RGB triplet), so Bootstrap's .text-danger renders green app-wide. Fixing
// that is out of scope here, so this warning icon sets its own red inline
// instead of depending on --bs-danger-rgb.
const WARNING_ICON_COLOR = '#ac0f35';

// The single job_status value that means the job is finished. The spec words it
// as "JOB COMPLETED"; the value the DOB NOW feed actually stores is "Job is
// complete" (the other stored values are "Job in Process" and "Inspection not
// complete due to withdrawal"). Held lower-cased because the comparison below is
// trimmed and case-insensitive.
const COMPLETED_JOB_STATUS = 'job is complete';

const WARNING_LABEL_PREFIX = 'Job Status: ';

function getColor(isOpen) {
	if (isOpen === 1 || isOpen === true) {
		return 'danger';
	} else if (isOpen === 0 || isOpen === false) {
		return 'success';
	}
	return 'secondary';
}

// Returns the trimmed job_status string, or null when the value is absent, blank
// or not a string.
function normalizeJobStatus(jobStatus) {
	if (typeof jobStatus !== 'string') {
		return null;
	}
	const trimmed = jobStatus.trim();
	return trimmed === '' ? null : trimmed;
}

// The warning sign is owed wherever the JOB status is not the completed value,
// keyed to job_status rather than to the filing-status-derived isOpen flag, and
// independent of which row renderer called this formatter. Fails closed: an
// absent, blank or non-string job_status is never treated as not-complete.
function shouldShowWarning(jobStatus) {
	return jobStatus !== null && jobStatus.toLowerCase() !== COMPLETED_JOB_STATUS;
}

// Renders the electrical filing status badge, plus a warning sign when the job
// behind the filing is not complete. The badge label is filing_status; the
// warning sign's tooltip and accessible name carry the job_status value, which
// this dataset no longer shows as its own column. Accepts an isChildRow prop
// from the grouped-row call sites and deliberately ignores it - the sign renders
// on parent and child rows alike.
function ElectricalFilingStatusBadge(props) {
	const { text, rowData } = props;
	const color = getColor(rowData?.isOpen);
	const jobStatus = normalizeJobStatus(rowData?.job_status);
	const showWarning = shouldShowWarning(jobStatus);
	const warningLabel = `${WARNING_LABEL_PREFIX}${jobStatus}`;

	return (
		<span style={{ display: 'inline-flex', alignItems: 'center' }}>
			<span className={`status-badge vio-badge badge bg-${color}`}>{text}</span>
			{showWarning && (
				<i
					className="bi bi-exclamation-circle-fill ms-2"
					style={{ color: WARNING_ICON_COLOR }}
					title={warningLabel}
					role="img"
					aria-label={warningLabel}
				/>
			)}
		</span>
	);
}

export default ElectricalFilingStatusBadge;
